import * as actionTypes from '../../Action/actionTypes';

export const setGuestUserDetails = (data) => {
  return {
    type: actionTypes.GUEST_USER_VALIDATION,
    value: data
  }
};
export const setBranchNameHandler = (data) => {
  return {
    type: actionTypes.GUEST_BRANCH_NAME,
    value: data
  }
};
export const setQRCovidResultViewer = (data) => {
  return {
    type: actionTypes.GUEST_QR_HR_COVID_RESULT,
    value: data
  }
};
export const setCurrentCorporateId = (data) => {
  return {
    type: actionTypes.GUEST_CURRENT_CORPORATE_ID,
    value: data
  }
};
